import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { marketDataIntegrationApi } from '@/api/services/marketDataIntegration';
import type { TenantActionInput } from '@/api/types/marketDataIntegration';

export const marketDataKeys = {
  all: ['marketDataIntegration'] as const,
  tenants: ['marketDataIntegration', 'tenants'] as const,
  cache: ['marketDataIntegration', 'cache'] as const,
  integration: ['marketDataIntegration', 'integration'] as const,
};

export function useTenants() {
  return useQuery({
    queryKey: marketDataKeys.tenants,
    queryFn: () => marketDataIntegrationApi.getTenants(),
  });
}

export function useRunIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: TenantActionInput) => marketDataIntegrationApi.runIntegration(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: marketDataKeys.integration }),
  });
}

export function useStopIntegration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: TenantActionInput) => marketDataIntegrationApi.stopIntegration(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: marketDataKeys.integration }),
  });
}
